const Event = {
  CHAT_THREAD_OPENED: 'chat_thread_opened',
  CHAT_MARKED_AS_READ_MANUAL: 'chat_marked_as_read_manual',
  CHAT_MARKED_AS_READ_ON_REPLY: 'chat_marked_as_read_on_reply',
  CHAT_CLOSED_UNREAD: 'chat_closed_unread',
  BEFORE_SENDING_MESSAGE: 'beforeSendingChatMessage',
  AFTER_SENDING_MESSAGE: 'afterSendingChatMessage',
  ARCHIVE_CHANNEL: 'archiveChannel',
  UNARCHIVE_CHANNEL: 'unarchiveChannel',
  SHOW_CHANNEL: 'showChannel',
  HIDE_CHANNEL: 'hideChannel',
  DUPLICATE_CHANNEL: 'duplicateChannel',
  COACHING_ACTIVITY: 'coachingActivity',
  SMART_CONTEXT_SIDEBAR_OPENED: 'smartContextSidebarOpened',
  // The thread inbox drawer, named after its sibling in the same slot.
  THREAD_INBOX_OPENED: 'threadInboxOpened',
  THREAD_INBOX_THREAD_OPENED: 'threadInboxThreadOpened',
  THREAD_INBOX_MARKED_READ: 'threadInboxMarkedRead',
  THREAD_INBOX_MARKED_ALL_READ: 'threadInboxMarkedAllRead',
  SMART_CONTEXT_INSERTED: 'smartContextInserted',
  SMART_CONTEXT_MESSAGE_SENT: 'smartContextMessageSent',
  SMART_CONTEXT_OPTION_CHANGED: 'smartContextOptionChanged',
  SMART_CONTEXT_SIDEBAR_CLOSED: 'smartContextSidebarClosed',
  SMART_CONTEXT_REGENERATE: 'smartContextRegenerate',
  SMART_CONTEXT_VIEWED: 'smartContextViewed',
  SMART_CONTEXT_COPIED: 'smartContextCopied',
};

const COACHING_ACTIVITY = {
  SINGLE_MESSAGE_SCHEDULED: 'singleMessageScheduled',
  QUEUE_SCHEDULED: 'queueScheduled',
};

export {
  Event,
  COACHING_ACTIVITY,
};
